export default [
    {
        name: 'fennec',
        type: 'gltfModel',
        path: 'models/cars/fennec.glb'
    },
    {
        name: 'octane',
        type: 'gltfModel',
        path: 'models/cars/octane.glb'
    },
    {
        name: 'dominus',
        type: 'gltfModel',
        path: 'models/cars/dominus.glb'
    },
    {
        name: 'alpha',
        type: 'gltfModel',
        path: 'models/wheels/alphaWheel.glb'
    },
    {
        name: 'cristiano',
        type: 'gltfModel',
        path: 'models/wheels/cristianoWheel.glb'
    },
    {
        name: 'dieci',
        type: 'gltfModel',
        path: 'models/wheels/dieciWheel.glb'
    },
    {
        name: 'urus',
        type: 'gltfModel',
        path: 'models/wheels/urusWheel.glb'
    },
    
    {
        name: 'skyline',
        type: 'gltfModel',
        path: 'models/wheels/skylineWheel.glb'
    },
    {
        name: 'fennecChassisColor',
        type: 'texture',
        path: 'textures/cars/fennec/ChassisColor.jpg'
    },
    {
        name: 'fennecChassisNormal',
        type: 'texture',
        path: 'textures/cars/fennec/ChassisNormal.jpg'
    },
    {
        name: 'fennecChassisEmissive',
        type: 'texture',
        path: 'textures/cars/fennec/ChassisEmissive.jpg'
    },
    {
        name: 'fennecPreset1',
        type: 'texture',
        path: 'textures/cars/fennec/presets/FennecM8.png'
    },
    {
        name: 'fennecPreset2',
        type: 'texture',
        path: 'textures/cars/fennec/presets/FennecKarmine.png'
    },
    {
        name: 'fennecPreset3',
        type: 'texture',
        path: 'textures/cars/fennec/presets/FennecGiants.png'
    },
    {
        name: 'fennecPreset4',
        type: 'texture',
        path: 'textures/cars/fennec/presets/FennecFuria.png'
    },
    {
        name: 'octaneChassisColor',
        type: 'texture',
        path: 'textures/cars/octane/ChassisColor.jpg'
    },
    {
        name: 'octaneChassisNormal',
        type: 'texture',
        path: 'textures/cars/octane/ChassisNormal.jpg'
    },
    {
        name: 'octaneChassisEmissive',
        type: 'texture',
        path: 'textures/cars/octane/ChassisEmissive.jpg'
    },
    {
        name: 'octanePreset1',
        type: 'texture',
        path: 'textures/cars/octane/presets/OctaneG2.png'
    },
    {
        name: 'octanePreset2',
        type: 'texture',
        path: 'textures/cars/octane/presets/OctaneElevate.png'
    },
    {
        name: 'octanePreset3',
        type: 'texture',
        path: 'textures/cars/octane/presets/OctaneBDS.png'
    },
    {
        name: 'octanePreset4',
        type: 'texture',
        path: 'textures/cars/octane/presets/OctaneNikeYellow.png'
    },
    {
        name: 'dominusChassisColor',
        type: 'texture',
        path: 'textures/cars/dominus/ChassisColor.jpg'
    },
    {
        name: 'dominusChassisNormal',
        type: 'texture',
        path: 'textures/cars/dominus/ChassisNormal.jpg'
    },
    {
        name: 'dominusChassisEmissive',
        type: 'texture',
        path: 'textures/cars/dominus/ChassisEmissive.jpg'
    },
    {
        name: 'dominusPreset1',
        type: 'texture',
        path: 'textures/cars/dominus/presets/DominusG2.png'
    },
    {
        name: 'dominusPreset2',
        type: 'texture',
        path: 'textures/cars/dominus/presets/DominusV1.png'
    },
    {
        name: 'dominusPreset3',
        type: 'texture',
        path: 'textures/cars/dominus/presets/DominusSolary.png'
    },
    {
        name: 'dominusPreset4',
        type: 'texture',
        path: 'textures/cars/dominus/presets/DominusBDS.png'
    },
    {
        name: 'tireColor',
        type: 'texture',
        path: 'textures/wheels/tire/TireColor.png'
    },
    {
        name: 'tireNormal',
        type: 'texture',
        path: 'textures/wheels/tire/TireNormal.png'
    },
    {
        name: 'tireRoughness',
        type: 'texture',
        path: 'textures/wheels/tire/TireRoughness.jpg'
    },
    {
        name: 'tireAO',
        type: 'texture',
        path: 'textures/wheels/tire/TireAO.jpg'
    },
    {
        name: 'alphaColor',
        type: 'texture',
        path: 'textures/wheels/alpha/AlphaColor.jpg'
    },
    {
        name: 'alphaNormal',
        type: 'texture',
        path: 'textures/wheels/alpha/AlphaNormal.jpg'
    },
    {
        name: 'urusColor',
        type: 'texture',
        path: 'textures/wheels/urus/UrusColor.jpg'
    },
    {
        name: 'urusNormal',
        type: 'texture',
        path: 'textures/wheels/urus/UrusNormal.jpg'
    },      
    {
        name: 'skylineColor',
        type: 'texture',
        path: 'textures/wheels/skyline/SkylineColor.jpg'
    },
    {
        name: 'skylineNormal',
        type: 'texture',
        path: 'textures/wheels/skyline/SkylineNormal.jpg'
    },  
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path: [
            'textures/environmentMap/px.png',
            'textures/environmentMap/nx.png',
            'textures/environmentMap/py.png',
            'textures/environmentMap/ny.png',
            'textures/environmentMap/pz.png',
            'textures/environmentMap/nz.png'
        ]
    },
    // {
    //     name: 'model3D',
    //     type: 'gltfModel',
    //     path: 'models/Chair/Chair.glb'
    // },
    // {
    //     name: 'baseTexture',
    //     type: 'texture',
    //     path: 'textures/Base/BaseTexture.jpg'
    // },
]